import { IconType } from 'react-icons';
import { Link } from 'react-router-dom';

type PropTypes = {
	to: string;
	innerText: string;
	isActive?: boolean;
	Icon?: IconType;
};
export default function Button({
	to,
	innerText,
	isActive,
	Icon,
	...props
}: PropTypes) {
	return (
		<Link
			to={to}
			className={`flex items-center justify-left font-bold gap-x-2 text-white my-2 mb-4 px-2 w-26 h-8 `}
			aria-disabled
			{...props}
		>
			{Icon && (
				<Icon
					size={24}
					color={isActive ? '#1d4ed8' : '#3b82f6'}
					title={innerText}
				/>
			)}
			<p
				className={`block ${
					isActive ? 'text-blue-700 ' : 'text-blue-500'
				}`}
			>
				{innerText}
			</p>
		</Link>
	);
}
